import { render, staticRenderFns } from "./poem.vue?vue&type=template&id=0ebd1f38&"
import script from "./poem.vue?vue&type=script&lang=js&"
export * from "./poem.vue?vue&type=script&lang=js&"
import style0 from "./poem.vue?vue&type=style&index=0&id=0ebd1f38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports